<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de atendimentos">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/relatorio-atendimento/List'

export default {
    components: { List },
}
</script>